import { format } from "date-fns";
import { InsuranceAttributesProps, PatientPhoneNumber } from "src/pages/addCase/types";

export const CASE_INDICATION = [
  {
    value: "DPN of the Foot",
    label: "Diabetic peripheral neuropathy of the feet (DPN)",
  },
  {
    value: "PHN",
    label: "Postherpetic polyneuropathy(PHN)",
  },
  {
    value: "Other",
    label: "Other",
  },
];

export const CASE_SITE_OF_CARE = [
  {
    value: "Provider Office",
    label: "Provider Office",
  },
  {
    value: "Hospital Outpatient Dept",
    label: "Hospital Outpatient Dept",
  },
  {
    value: "Other",
    label: "Other",
  },
];

export const DEFAULT_PRESCRIPTION_VALUES = {
  indication: "",
  qty: undefined,
  direction: "",
  note: "",
  jcode: "J7336",
  diagnosis_code: [],
  written_date: format(new Date(), "MM/dd/yyyy")
}

export const DEFAULT_CASE_ATTRIBUTES = {
  mos: "online",
  category: "medrx",
  submission_source: "provider",
  prescription_attributes: DEFAULT_PRESCRIPTION_VALUES,
  procedure_attributes: { cpt_code: undefined },
  shipments_attributes: [{
    ship_to: "Provider Office",
  }],
  patient_attributes: {
    phone_numbers: [
      {
        phone_type: "cell",
        id: null,
      } as PatientPhoneNumber,
    ],
    address: {
      address_name: "home"
    },
    reinvestigation: false,
    outreach: true,
    // pcc_outreach: false,
  },
  insurances_attributes: [
    {
      global_insurance_id: null,
      is_primary_insurance: true,
      relation_to_patient: "self",
      insurance_priority: 0,
    } as InsuranceAttributesProps,
  ],
}
